<form
  [appDynamicPhoneValidation]="dynamicPhoneDirectiveConfig"
  [formGroup]="form"
  class="flex flex-col gap-8 max-w-[506px]"
  appHandleClerkCreateEstateSubmit>
  <div>
    <p class="text-sm italic neutral-900 font-stretch-condensed mb-5">
      Use this option if you are applying in your personal capacity. If you are
      applying on behalf of a business or legal entity, select "Firm" instead.
    </p>
    <mat-slide-toggle class="ccs-toggle" formControlName="isFirm"
      >Applying as a Firm</mat-slide-toggle
    >
  </div>
  @if (!isFirm()) {
    <div class="flex flex-col gap-1">
      <app-autocomplete
        [isFirm]="form.controls.isFirm.value"
        [options]="formattedUsersByName()"
        [loading]="isLoading()"
        appHandleUserSearch
        appHandleAutocompleteOptionClick
        [searchType]="'firstName'"
        formControlName="firstName"
        label="First Name" />

      @if (
        form.controls['firstName'].invalid && form.controls['firstName'].touched
      ) {
        @if (form.controls['firstName'].errors?.['required']) {
          <form-message message="First Name is required." />
        }
        @if (form.controls['firstName'].errors?.['minlength']) {
          <form-message
            message="First Name must be at least 2 characters long." />
        }
        @if (form.controls['firstName'].errors?.['pattern']) {
          <form-message message="First Name should have a valid format" />
        }
      }
    </div>
    <div class="flex flex-col gap-1">
      <app-ccs-input
        formControlName="middleName"
        label="Middle Name (Optional)"
        placeholder="Enter your middle name"
        size="md"
        [errorMessages]="ERROR_MESSAGES.middle_name" />
    </div>
    <div class="flex flex-col gap-1">
      <app-ccs-input
        formControlName="lastName"
        label="Last Name"
        placeholder="Enter your last name"
        size="md"
        [errorMessages]="ERROR_MESSAGES.last_name" />
    </div>
  } @else {
    <div class="flex flex-col gap-1">
      <app-autocomplete
        [isFirm]="form.controls.isFirm.value"
        [options]="formattedUsersByName()"
        [loading]="isLoading()"
        appHandleUserSearch
        appHandleAutocompleteOptionClick
        [searchType]="'firstName'"
        formControlName="firstName"
        label="Firm Name" />

      @if (
        form.controls['firstName'].invalid && form.controls['firstName'].touched
      ) {
        @if (form.controls['firstName'].errors?.['required']) {
          <form-message message="Firm Name is required." />
        }
        @if (form.controls['firstName'].errors?.['minlength']) {
          <form-message
            message="Firm Name must be at least 2 characters long." />
        }
        @if (form.controls['firstName'].errors?.['pattern']) {
          <form-message message="Firm Name should have a valid format" />
        }
      }
    </div>
  }
  <div class="grid gap-x-2 grid-cols-2">
    <app-ccs-select
      className="h-12"
      label="Phone Prefix"
      size="md"
      displayKey="label"
      valueKey="value"
      formControlName="prefixPhone"
      placeholder="Select an option"
      [options]="phonePrefixOptions" />
    @if (isPhonePrefixUS) {
      <app-ccs-input
        appPhoneNumberMask
        formControlName="phoneNumber"
        label="Phone Number (Optional)"
        placeholder="Enter your phone number"
        [errorMessages]="ERROR_MESSAGES.phone_number"
        size="md" />
    } @else {
      <app-ccs-input
        formControlName="phoneNumber"
        label="Phone Number (Optional)"
        placeholder="Enter your phone number"
        size="md"
        [errorMessages]="ERROR_MESSAGES.phone_number" />
    }
  </div>
  <div class="flex flex-col gap-1">
    <app-autocomplete
      [isFirm]="form.controls.isFirm.value"
      appHandleAutocompleteOptionClick
      [searchType]="'email'"
      [options]="formattedUsersByEmail()"
      [loading]="isLoading()"
      appHandleUserSearch
      formControlName="email"
      label="Email address (Optional)" />
    @if (form.controls['email'].invalid && form.controls['email'].touched) {
      @if (form.controls['email'].errors?.['required']) {
        <form-message message="Email is required." />
      }
      @if (form.controls['email'].errors?.['pattern']) {
        <form-message message="Please enter a valid email address." />
      }
    }
  </div>
  <div class="flex flex-col gap-1">
    <app-ccs-input
      formControlName="username"
      label="Username"
      placeholder="Enter your username"
      size="md"
      [errorMessages]="ERROR_MESSAGES.username" />
  </div>
  <div class="flex flex-col-reverse sm:flex-row gap-2 sm:gap-4">
    <ui-button
      [disabled]="isSending()"
      variant="tertiary"
      class="w-full"
      appCloseApplicationModal>
      Cancel
    </ui-button>
    <ui-button
      variant="primary"
      class="w-full"
      [disabled]="form.invalid || isSending()"
      [loading]="isSending()"
      type="submit">
      Create
    </ui-button>
  </div>
</form>
